import { useRef } from "react";
import Pdf from "react-to-pdf";

import { ModalTopSection } from "../../../../components/DetailsModal/ModalTopSection";
import {
  ModalContainer,
  SectionSubheader,
  SwitchAppButton,
} from "../../../../components";
import { CurrencyDisplay } from "../../../../components";
import { Badge } from "../../../../components";
import { ITransferReceiptModalViewProps } from "./TransferReceiptModal";
import { getTransferStatusIndicator } from "../../../../utils";
import { ReceiptTemplate } from "./ReceiptTemplate";
import { ReceiptTemplateSkeletonLoader } from "./ReceiptTemplateSkeletonLoader";

import downloadIcon from "../../../../assets/icons/arrowdown.svg";
import { transferStatus } from "../../../../enums";

export const View = (props: ITransferReceiptModalViewProps) => {
  const ref = useRef<HTMLImageElement | null>(null);

  const statusIndicator = !props.transfer
    ? null
    : getTransferStatusIndicator(props.transfer);

  return (
    <div className="payment-details-container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="payment-modal-container"
        modalHeader={
          !props.transfer ? (
            <SectionSubheader title="TRANSFER RECEIPT" />
          ) : (
            <ModalTopSection
              header="TRANSFER RECEIPT"
              subHeader={
                <div className="sub-header flex-container justify-content--start mt-5">
                  <div>
                    <CurrencyDisplay
                      currencyOrSymbol={props.transfer.currency}
                      amount={props.transfer.amount}
                    />
                  </div>

                  <Badge
                    text={statusIndicator!.statusText}
                    statusColor={statusIndicator!.statusType}
                  />

                  {!props.receiptImageRenderingComplete ? null : (
                    <div className="mt-n5 flex-container align-items--end">
                      <SwitchAppButton
                        onClick={() => props.downloadReceiptImage("png")}
                        kind="primary"
                        size="sm"
                        className="ml-5"
                      >
                        Image
                        <img src={downloadIcon} alt="print document" />
                      </SwitchAppButton>

                      {props.receiptImageElement && (
                        <Pdf
                          targetRef={ref}
                          filename={`Transfer Receipt ${
                            props.transfer!.reference
                          }.pdf`}
                          options={{ orientation: "portrait" }}
                          scale={0.9}
                        >
                          {({ toPdf }: { toPdf: any }) => (
                            <SwitchAppButton
                              onClick={toPdf}
                              kind="danger"
                              size="sm"
                              className="ml-5"
                            >
                              PDF
                              <img src={downloadIcon} alt="print document" />
                            </SwitchAppButton>
                          )}
                        </Pdf>
                      )}
                    </div>
                  )}
                </div>
              }
              copyText="Transfer REF"
              copyContent={props.transfer.reference}
              closeModal={props.closeModal}
            />
          )
        }
      >
        <div id="transfer-receipt--container">
          {!props.receiptImageElement ? null : (
            <img
              ref={ref}
              src={props.receiptImageElement.src}
              alt={props.receiptImageElement.alt}
            />
          )}

          {props.transfer?.status === transferStatus.processing ? (
            <div className="text-danger">Transfer is still in progress...</div>
          ) : props.isHtmlReceiptHidden ? null : (
            <div
              id="transfer-receipt"
              className="flex-container col justify-content--center align-items--center"
              style={{
                visibility: `${
                  !props.receiptImageElement ? "visible" : "hidden"
                }`,
              }}
            >
              {!props.transfer ? (
                <ReceiptTemplateSkeletonLoader />
              ) : (
                <ReceiptTemplate {...props.transfer} />
              )}
            </div>
          )}
        </div>
      </ModalContainer>
    </div>
  );
};
